var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVandposter = function SvgVandposter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#113628",
    strokeMiterlimit: 10,
    strokeWidth: 0.903,
    d: "M5.161 1h4.065m-.903 2.258h2.258a2.71 2.71 0 0 1 2.71 2.71v1.355h-2.71V6.45c0-.515-.389-.935-.904-.935H2m0-2.258h4.065m2.258.452v-.226a1.13 1.13 0 0 0-2.258 0v.226m6.783 7.776c.316.344.894.985.894 1.707A1.783 1.783 0 0 1 11.935 15a1.783 1.783 0 0 1-1.806-1.806c0-.696.537-1.31.908-1.712l.898-.998z"
  })));
};
export default SvgVandposter;